/* eslint-disable */

import "./App.css";
import Footer from "./components/layouts/footer";
import Header from "./components/layouts/header";
import Section from "./components/layouts/section";

function App() {
  return (
    <div className="App">
      <Header />
      <Section />
      <Footer />
    </div>
  );
}

export default App;
